import Cookies from 'js-cookie';

export function electronLog(content) {
  // get enterprise id
  const enterpriseId = Cookies.get('_enterprise_id');
  // 只允许环球打印日志
  if (enterpriseId === '18233' || enterpriseId === '1' || enterpriseId === '358074') {
    window?.electron?.ipcRenderer?.send('wlog', content);
  }
}
